import React from 'react';
import Paper from '@material-ui/core/Paper';
import {makeStyles} from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    paddingRight: 20,
    paddingLeft: 20,
    boxShadow:'none'
  },
});

export default function CustomTabs(props) {
  const classes = useStyles();

  const {tabsList, activeTab, handleChange, role, handleChangeRole} = props;

  return (
    <Paper square className={classes.root}>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        variant="fullWidth"
        // indicatorColor="primary"
        // textColor="primary"
        aria-label="icon label tabs example"
        // updateIndicator={()=>color:'red'}
      >
        {(tabsList || []).map((tab, index) => (
          <Tab icon={tab.icon && <tab.icon/>} label={tab.label}/>
        ))}
      </Tabs>
    </Paper>
  );
}


// <Paper square className={classes.root}>
//   <Tabs
//     value={role}
//     onChange={handleChangeRole}
//     variant="fullWidth"
//     indicatorColor="primary"
//     textColor="primary"
//     aria-label="icon label tabs example"
//   >
//     <Tab icon={<LineStyleOutlinedIcon/>} label="CP Manager"/>
//     <Tab icon={<AccountBalanceWalletOutlinedIcon/>} label="Finance"/>
//     <Tab icon={<PersonPinIcon/>} label="Commercial Team"/>
//     {/*<Tab icon={<img src={person}/>} label="Media Team" />*/}
//     <Tab icon={<MovieCreationOutlinedIcon/>} label="Media Team"/>
//   </Tabs>
// </Paper>
